module.exports = __webpack_public_path__ + "static/media/emoji-icon.71250a2c.svg";